import UpgradeModal from '@/components/UpgradeModal';
import { useUpgradeModalStore } from '@/stores/upgradeModalStore';

/**
 * App-root mount for the upgrade flow. The axios interceptor
 * (`src/api/client.ts`) calls `useUpgradeModalStore.trigger(reason)` when the
 * backend raises `PLAN_LIMIT_EXCEEDED` (403). Mounting the modal once here —
 * rather than doing a full-page redirect to /settings#billing-plans — keeps
 * the user on their current page with their form state intact and shows
 * exactly which cap they hit (BUG-060).
 */
export default function GlobalUpgradeModal() {
  const open = useUpgradeModalStore((s) => s.open);
  const reason = useUpgradeModalStore((s) => s.reason);
  const close = useUpgradeModalStore((s) => s.close);

  return <UpgradeModal open={open} onClose={close} reason={reason} />;
}
